<template>
  <div :class="skinType == 2 ? 'bg_gray' : 'bg_white'">
    <p class="nothing-tips" v-if="modleDataShow && !list">暂无数据</p>
    <hgroup class="mainPage cgbd">
      <div class="m-table-block">
        <table class="m-table-four">
          <tr>
            <th><span>公告日期</span></th>
            <th><span>港股普通股</span></th>
            <th><span>变动数量</span></th>
            <th><span>变动原因</span></th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{ item.fbrq }}</td>
            <td>{{ process(item.gbsl) }}</td>
            <td :class="item.bdfx | textColor">
              <span :class="item.bdfx | riseFilter">{{ process(item.bdsl) }}</span>
            </td>
            <td>
              <span>{{ item.bdyybz }}</span>
            </td>
          </tr>
        </table>
      </div>
    </hgroup>
    <Loading v-if="!modleDataShow"></Loading>
    <Declare v-if="modleDataShow && !list"></Declare>
  </div>
</template>

<script>
import { getJson } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading"
import Declare from "../components/declare"
export default {
  name: "Home",
  data() {
    return {
      rootStr: "/wap/data/ipad/stock/",
      code: "",
      skinType: 2,
      list: [],
      modleDataShow: false,
    };
  },
  mixins: [mixins],
  components:{Loading,Declare},
  filters: {
    textColor: function (num) {
      if (num === 1) {
        return "red";
      } else if (num === 2) {
        return "green";
      }
    },
    riseFilter:function(num){
      if (num === 1) {
        return "riseUp";
      } else if (num === 2) {
        return "riseDown";
      }
    }
  },
  created() {
    document.title = decodeURI(this.getUrlQuery("name")) + "F10";
    if (this.getUrlQuery("themeStyleVs") == 2) {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#0c0f13;");
    } else {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#FFF;");
    }
    this.skinType = this.getUrlQuery("themeStyleVs");
    this.code = this.getUrlQuery("code");
    this.$nextTick(function () {
      this.getData();
    });
  },
  mounted() {},
  methods: {
    getData: function () {
      let code = this.code;
      var url = window.config.url + this.rootStr + this.stockCodeUrl(code) + "/f10/gbgd_gbbd_more.json";
      getJson(url).then((res) => {
          this.list = res.dataList;
          this.modleDataShow = true;
        })
        .catch((err) => {
          console.log(err, "err");
          this.modleDataShow = true;
        });
    },
  },
};
</script>
<style lang="less">
@import "../assets/css/style2.less";
</style>
